<template>
  <div class="container">
    <div class="block">
      <div class="title-wrap">
        <div
          class="title-jump"
          @click="$router.push({ name: 'updateBaseInfo' })"
        >
          修改基础信息<i class="el-icon-arrow-right"></i>
        </div>
        <div class="title-name">基础信息</div>
      </div>
      <div class="content-inner-wrap" v-loading="baseInfoLoading">
        <div class="studio-info" :data-studioid="studioId">
          <img class="avatar" :src="studioHead" />
          <div class="info">
            <h2>{{ studioName }}</h2>
            <p>室长：{{ leaderName }}</p>
            <p>工作室ID: {{ studioId }}</p>
          </div>
        </div>
        <div class="info-item studio-desc">
          <div class="label">简介：</div>
          <div class="details">{{ description }}</div>
        </div>
        <div class="info-item studio-notice">
          <div class="label">公告：</div>
          <div class="details">
            {{ notice }}
          </div>
        </div>
      </div>
    </div>
    <div class="block">
      <div class="title-wrap">
        <div class="title-name">经营概况</div>
      </div>
      <div class="content-inner-wrap">
        <div class="managementData">
          <div class="management-item managementProfit">
            <div class="mana-left">
              <h4>本月收益</h4>
              <label v-html="MonthMoney"></label>
            </div>
            <div class="mana-right">
              <h4>累计收益</h4>
              <label v-html="TotalMoney"></label>
            </div>
          </div>
          <div class="management-item managementProduct">
            <div class="mana-left">
              <h4>工作室成员</h4>
              <label>{{ member_count }}</label>
            </div>
            <div class="mana-right">
              <h4>作品数</h4>
              <label>{{ map_count }}</label>
            </div>
          </div>
        </div>
        <div class="managementRules">
          <p>1. 以上收益需等待入账后才可进入【结算中心】提现</p>
          <p>2. 每日0点-1点更新昨日收益数据</p>
          <p>
            3. 收益数据为预估数据，最终收益以入账后金额为准，具体细则请查看<a
              target="_blank"
              href="https://mnweb.mini1.cn/activity/docs/settlement_proto_20210521.html"
              >《收益结算说明》</a
            >
          </p>
        </div>
      </div>
    </div>

    <div class="block block-flow" v-if="permission">
      <div class="title-wrap">
        <div class="title-jump" @click="$router.push({ name: 'dataDetails' })">
          数据明细<i class="el-icon-arrow-right"></i>
        </div>
        <div class="title-name">流水趋势</div>
        <div class="title-desc">工作室收益为工作室所有成员收益之和</div>
      </div>
      <div class="content-inner-wrap">
        <h3>近7天数据</h3>
        <div class="managementData">
          <div
            class="management-item"
            :class="{ active: currFlowType === 'adIncomes' }"
            @click="getChartsData('adIncomes')"
          >
            <div class="mana-left">
              <h4>广告收入</h4>
              <label>{{ adIncome }}</label>
            </div>
          </div>
          <div
            class="management-item"
            :class="{ active: currFlowType === 'contributions' }"
            @click="getChartsData('contributions')"
          >
            <div class="mana-left">
              <h4>贡献点收入</h4>
              <label>{{ contributionIncome }}</label>
            </div>
          </div>
          <div
            class="management-item"
            :class="{ active: currFlowType === 'miniDots' }"
            @click="getChartsData('miniDots')"
          >
            <div class="mana-left">
              <h4>迷你点收入</h4>
              <label>{{ minipointIncome }}</label>
            </div>
          </div>
          <div
            class="management-item"
            :class="{ active: currFlowType === 'others' }"
            @click="getChartsData('others')"
          >
            <div class="mana-left">
              <h4>其他收入</h4>
              <label>{{ otherIncome }}</label>
            </div>
          </div>
          <div
            class="management-item"
            :class="{ active: currFlowType === 'miniBeans' }"
            @click="getChartsData('miniBeans')"
          >
            <div class="mana-left">
              <h4>迷你豆收入</h4>
              <label>{{ miniBeansIncome }}</label>
            </div>
          </div>
          <div
            class="management-item"
            :class="{ active: currFlowType === 'adCount' }"
            @click="getChartsData('adCount')"
          >
            <div class="mana-left">
              <h4>广告播放次数</h4>
              <label>{{ adCounts }}</label>
            </div>
          </div>
        </div>
        <div id="flow-chart">
          <ve-line :data="flowChartData"></ve-line>
          <!-- <div class="img-no-data" v-else>
          <img src="../../assets/images/img_map_no_data.png" />
          <p>您暂时还没有数据呢</p>
        </div> -->
        </div>
      </div>
    </div>

    <div class="block block-product">
      <div class="title-wrap">
        <div class="title-jump" @click="$router.push({ name: 'dataDetails' })">
          数据明细<i class="el-icon-arrow-right"></i>
        </div>
        <div class="title-name">作品数据</div>
        <div class="title-desc">归属于工作室的作品活跃数据</div>
      </div>
      <div class="content-inner-wrap">
        <h3>近7天数据</h3>
        <div class="managementData">
          <div
            class="management-item"
            :class="{ active: currProFlowType === 'totalProducts' }"
            @click="getProChartsData('totalProducts')"
          >
            <div class="mana-left">
              <!--  <h4>作品总数<em> 昨日活跃作品</em></h4>   -->
              <h4>昨日活跃作品</h4>
              <label>{{ map_total }}</label>
            </div>
          </div>
          <div
            class="management-item"
            :class="{ active: currProFlowType === 'newProduct' }"
            @click="getProChartsData('newProduct')"
          >
            <div class="mana-left">
              <!--  <h4>新作品<em> 昨日新增作品</em></h4>  -->
              <h4>昨日新增作品</h4>
              <label>{{ newly_total }}</label>
            </div>
          </div>
          <div
            class="management-item"
            :class="{ active: currProFlowType === 'perDayPlayers' }"
            @click="getProChartsData('perDayPlayers')"
          >
            <div class="mana-left">
              <!--    <h4>每日游戏人数<em> 昨日游戏人数</em></h4>  -->
              <h4>昨日游戏人数</h4>
              <label>{{ play_total }}</label>
            </div>
          </div>
          <div
            class="management-item"
            :class="{ active: currProFlowType === 'productDownloads' }"
            @click="getProChartsData('productDownloads')"
          >
            <div class="mana-left">
              <!--    <h4>作品下载数据<em> 昨日游戏下载数据</em></h4>  -->
              <h4>昨日游戏下载数据</h4>
              <label>{{ map_download_total }}</label>
            </div>
          </div>
        </div>
        <div id="flow-chart">
          <ve-line :data="productChartData"></ve-line>
        </div>
      </div>
    </div>
    <div class="block-wrap">
      <div class="block block-members" v-loading="memberDataLoading">
        <div class="title-wrap">
          <!-- <div class="title-jump">查看全部动态<i class="el-icon-arrow-right"></i></div> -->
          <div class="title-name">成员动态</div>
        </div>
        <div class="content-inner-wrap">
          <div class="members-activity">
            <div
              class="member"
              v-for="(item, index) in membersHistory.slice(
                (currentPage - 1) * 7,
                currentPage * 7,
              )"
              :key="index"
            >
              <img
                :src="`http://map1.mini1.cn/roleicon/${item.target_head_id}.png`"
              />
              <div class="member-info">
                <p v-html="item.text"></p>
                <label>{{ item.time | getTimeName }}</label>
              </div>
            </div>
          </div>
        </div>
        <!--分页-->
        <div class="data-filter-page" v-if="membersHistory.length">
          <el-pagination
            background
            layout="prev,pager,next"
            :page-size="7"
            :pager-count="5"
            :total="total_history"
            @current-change="pageMemberHistoryChange"
          >
          </el-pagination>
        </div>
      </div>
      <div class="block block-rank" v-loading="rankDataLoading">
        <div class="title-wrap">
          <div class="title-jump title-jump-gray">
            更新时间{{ rankCountDate }}
          </div>
          <div class="title-name">每周作品下载排行榜</div>
          <div class="title-desc">根据作品的下载人数，每周更新</div>
        </div>
        <div class="content-inner-wrap">
          <el-table id="rankTable" :data="rankData" :fit="false" height="450">
            <el-table-column
              align="center"
              prop="index"
              label="排名"
              width="40"
              class-name="tb-index"
            >
              <template slot-scope="scope">
                <div v-html="scope.row.index"></div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="map"
              label="地图"
              width="250"
              class-name="tb-map"
            >
              <template slot-scope="scope">
                <img :src="scope.row.map.img" />
                <span>{{ scope.row.map.desc }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="author"
              label="作者"
              width="128"
              class-name="tb-author"
            >
              <template slot-scope="scope">
                <img :src="scope.row.author.img" />
                <span>{{ scope.row.author.name }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="downloads"
              label="下载量"
              width="90"
              class-name="tb-downloads"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="rankto"
              label=""
              width="24"
              class-name="tb-rankto"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getStudioIncomeOverview,
  getStudioIncomeDiagram,
  getStudioDetail,
  getPermiss,
  getStudioMemberHistory,
  getOneWeekProductData,
  getOneWeekProductRank,
} from '@/api/studio';
import {
  ONE_DAY,
  DESCRIPTION_DEFAULT,
  NOTICE_DEFAULT,
  handleMembersHistory,
} from './CONST';
const D_TYPE = {
  mapDownloads: { value: 1, label: '作品下载数据' }, // 地图下载
  mapBrowse: { value: 2, label: '地图浏览量' }, // 地图浏览
  mapPlayTimes: { value: 3, label: '地图游玩次数' }, // 地图游玩次数
  mapPlayTime: { value: 4, label: '地图游玩时间' }, // 地图游玩时间
  mapComments: { value: 5, label: '地图评论数' }, // 地图评论
  mapBlocks: { value: 6, label: '地图投块' }, // 地图投块
  mapLikes: { value: 7, label: '地图点赞数' }, // 地图点赞
  mapFavorites: { value: 8, label: '地图收藏数' }, //地图收藏
  adIncomes: { value: 9, label: '广告收入' }, // 广告收入
  contributions: { value: 10, label: '贡献点收入' }, // 贡献点
  miniBeans: { value: 11, label: '迷你豆' }, // 迷你豆
  miniDots: { value: 12, label: '迷你点收入' }, // 迷你点
  others: { value: 13, label: '其他收入' }, // 其他收入
  adCount: { value: 14, label: '广告播放次数' }, // 广告播放次数
};
const P_TYPE = {
  totalProducts: { value: 1, label: '昨日活跃作品' },
  newProduct: { value: 2, label: '昨日新增作品' },
  perDayPlayers: { value: 3, label: '昨日游戏人数' },
  productDownloads: { value: 4, label: '昨日游戏下载数据' },
};

const PROD_ARR_KEY = [
  '日期',
  '昨日活跃作品',
  '昨日新增作品',
  '昨日游戏人数',
  '昨日游戏下载数据',
];

export default {
  data() {
    return {
      memberDataLoading: false,
      rankDataLoading: false,
      baseInfoLoading: false,
      rankCountDate: '',
      studioId: 0,
      position: 0,
      permission: true, //是否拥有权限
      notice: NOTICE_DEFAULT,
      description: DESCRIPTION_DEFAULT,
      studioName: '',
      leaderName: '',
      studioHead: '',
      currFlowType: 'adIncomes',
      currProFlowType: 'totalProducts',
      monthMoney: 0,
      totalMoney: 0,
      adIncome: 0,
      adCounts: 0,
      otherIncome: 0,
      minipointIncome: 0,
      miniBeansIncome: 0,
      contributionIncome: 0,
      map_count: 0,
      map_download: 0,
      member_count: 0,
      map_download_total: 0,
      map_total: 0,
      newly_total: 0,
      play_total: 0,
      flowChartData: {
        columns: ['日期', '广告收入', '贡献点收入', '迷你电收入', '其他收入'],
        rows: [],
      },
      productChartData: {
        columns: [...PROD_ARR_KEY],
        rows: [],
      },
      rankData: [],
      membersHistory: [],
      cacheProChartData: [],
      currentPage: 1, //记录当前页码
      total_history: 0,
      labelPage: 1,
    };
  },
  async mounted() {
    //工作室概况页曝光埋点
    this.$log('studio_overview_show', 85441, { v7: 1 });
    this.Report('view', 'StudioPage', { v3: 'manager' });
    this.baseInfoLoading = true;
    let baseInfo = sessionStorage.getItem('studioBaseInfo');
    if (baseInfo) {
      baseInfo = JSON.parse(baseInfo);
    } else {
      let res = await getStudioDetail({ json: 1 });
      sessionStorage.setItem('studioBaseInfo', JSON.stringify(res.data));
      baseInfo = res.data;
    }
    this.baseInfoLoading = false;
    this.description = baseInfo.description || DESCRIPTION_DEFAULT;
    this.notice = baseInfo.notice || NOTICE_DEFAULT;
    this.studioName = baseInfo.name;
    this.studioHead = baseInfo.head;
    this.leaderName = baseInfo.leader_name;
    this.studioId = baseInfo.studio_id;
    this.map_download = baseInfo.map_download;
    this.map_count = baseInfo.map_count;
    this.member_count = baseInfo.member_count;
    getOneWeekProductData({ json: 1 }).then(res => {
      const len = (res.data && res.data.length) || 0;
      if (len) {
        let lastItem = res.data[len - 1];
        this.map_download_total = lastItem.dl;
        this.map_total = lastItem.total;
        this.newly_total = lastItem.newly;
        this.play_total = lastItem.play;
        this.cacheProChartData = res.data.map(val => {
          return {
            [PROD_ARR_KEY[0]]: val.count_date + '',
            [PROD_ARR_KEY[1]]: val.total,
            [PROD_ARR_KEY[2]]: val.newly,
            [PROD_ARR_KEY[3]]: val.play,
            [PROD_ARR_KEY[4]]: val.dl,
          };
        });
      }
      this.getProChartsData(this.currProFlowType, true);
    });
    //拉取数据
    this.memberDataLoading = true;
    //获取收入权限
    this.getPerssion();
    getStudioMemberHistory({ page: 1, page_size: 30, json: 1 }).then(res => {
      this.memberDataLoading = false;
      this.membersHistory.push(...handleMembersHistory(res.data));
      //this.membersHistory = handleMembersHistory(res.data);
      this.total_history = this.membersHistory.length;
      //判断动态是否取完全
      // this.getNewStudioMemberHistory();
      if (parseInt(res.data.length) % 30 === 0) {
        this.labelPage = this.labelPage + 1;
        this.getNewStudioMemberHistory();
        //debugger;
      }
    });
    this.getChartsData(this.currFlowType, true);
    this.rankDataLoading = true;
    getOneWeekProductRank({ json: 1 }).then(res => {
      let { list, count_date } = res.data;
      this.rankCountDate = count_date;
      this.rankDataLoading = false;
      this.rankData = list.map((item, index) => {
        let val = {
          id: item.uin,
          index: this.renderIndex(index),
          downloads: item.new_downloads,
        };
        val.map = {
          img: item.thumb_url,
          desc: item.map_name,
        };
        val.author = {
          img: `http://map1.mini1.cn/roleicon/${item.head_id}.png`,
          name: item.name,
        };
        val.rankto = item.new_downloads > item.old_downloads ? '↑' : '↓';
        return val;
      });
    });
    getStudioIncomeOverview().then(res => {
      let {
        month_money,
        total_money,
        ad_income,
        contribution,
        minipoint,
        other,
        ad_count,
        minibean,
      } = res.data;
      this.monthMoney = month_money;
      this.totalMoney = total_money;
      this.adIncome = ad_income;
      this.contributionIncome = Number(contribution).toFixed(3);
      this.minipointIncome = minipoint;
      this.otherIncome = other;
      this.adCounts = ad_count;
      this.miniBeansIncome = minibean;
    });
  },
  computed: {
    MonthMoney() {
      return this.renameMoney(this.monthMoney);
    },
    TotalMoney() {
      return this.renameMoney(this.totalMoney);
    },
    hasFlowChartData() {
      return !!this.flowChartData.rows.length;
    },
    hasProductChartData() {
      return !!this.productChartData.rows.length;
    },
  },
  filters: {
    getTimeName(time) {
      time *= 1000;
      const ONE_MINI = 1000 * 60;
      const ONE_HOUR = ONE_MINI * 60;
      const ONE_WEEK = ONE_DAY * 7;
      const ONE_MONTH = ONE_DAY * 30;
      const ONE_YEAR = ONE_DAY * 365;
      let currTime = Date.now();
      let diffVal = currTime - time;
      if (diffVal > ONE_YEAR) {
        // 再远就不管了
        return '1年前';
      } else {
        let months = Math.floor(diffVal / ONE_MONTH);
        if (months) {
          return `${months}个月前`;
        } else {
          let weeks = Math.floor(diffVal / ONE_WEEK);
          if (weeks) {
            return `${weeks}周前`;
          } else {
            let days = Math.floor(diffVal / ONE_DAY);
            if (days) {
              return `${days}天前`;
            } else {
              let hours = Math.floor(diffVal / ONE_HOUR);
              if (hours) {
                return `${hours}小时前`;
              } else {
                let minutes = Math.floor(diffVal / ONE_MINI);
                if (minutes) {
                  return `${minutes}分钟前`;
                } else {
                  let seconds = Math.floor(diffVal / 1000);
                  if (seconds) {
                    return `${seconds}秒前`;
                  } else {
                    return '刚刚';
                  }
                }
              }
            }
          }
        }
      }
    },
  },
  methods: {
    getOneWeekDefaultData(currProFlowType) {
      return this.getDefaultDataOneWeek(P_TYPE[currProFlowType].label);
    },
    async getPerssion() {
      let data = { json: 1 };
      let res = await getPermiss(data);
      this.position = res.data.position;
      if (res.data.v1m_income == 1 || this.position == 1) {
        this.permission = true;
      } else {
        this.permission = false;
      }
    },
    getFlowChartDataDefault(label) {
      return this.getDefaultDataOneWeek(label);
    },
    getDefaultDataOneWeek(label) {
      let initTime = Date.now();
      let resArr = [];
      let obj = {
        日期: '',
        [label]: 0,
      };
      for (let i = 0; i < 7; i++) {
        let t = new Date(initTime - ONE_DAY * (6 - i));
        obj['日期'] =
          (t.getFullYear() + '').slice(-2) +
          '/' +
          (101 + t.getMonth() + '').slice(-2) +
          '/' +
          (100 + t.getDate() + '').slice(-2);
        resArr.push(JSON.parse(JSON.stringify(obj)));
      }
      return resArr;
    },
    getChartsData(type, first) {
      if (type === this.currFlowType && !first) return;
      let _type = D_TYPE[type];
      getStudioIncomeDiagram({ dtype: _type.value }).then(res => {
        console.info('getStudioIncomeDiagram', res);
        if (res.code === 0) {
          this.currFlowType = type;
          let { list } = res.data;
          this.flowChartData.columns = ['日期', _type.label];
          this.flowChartData.rows = list.map(val => {
            return { 日期: val.date, [_type.label]: val.num };
          });
          if (!this.flowChartData.rows.length) {
            this.flowChartData.rows = this.getFlowChartDataDefault(_type.label);
          }
        }
      });
    },
    //分页绑定函数
    pageMemberHistoryChange(page) {
      this.currentPage = page;
    },
    //动态数>30
    getNewStudioMemberHistory() {
      //debugger;
      getStudioMemberHistory({
        page: this.labelPage,
        page_size: 30,
        json: 1,
      }).then(res => {
        this.memberDataLoading = false;
        this.membersHistory.push(...handleMembersHistory(res.data));
        this.total_history = this.membersHistory.length;
        //if(this.total_history%30==0)this.getNewStudioMemberHistory()
      });
    },
    getProChartsData(type, first) {
      if (type === this.currProFlowType && !first) return;
      this.currProFlowType = type;
      let _type = P_TYPE[type];
      this.productChartData.columns = ['日期', _type.label];
      let tmp = this.cacheProChartData.map(val => {
        return { 日期: val['日期'], [_type.label]: val[_type.label] };
      });
      this.productChartData.rows = tmp.length
        ? tmp
        : this.getOneWeekDefaultData(this.currProFlowType);
    },
    renameMoney(money) {
      let res = money;
      if (money < 999999) {
        res = money;
      } else {
        res = (money / 10000).toFixed(2) + '<i>万</i>';
      }
      if (!this.permission) res = '无权限查看';
      return res;
    },
    renderIndex(index) {
      if (index > 2) return 1 + index;
      switch (index) {
        case 0:
          index = '<i class="icon icon-top-first"></i>';
          break;
        case 1:
          index = '<i class="icon icon-top-second"></i>';
          break;
        case 2:
          index = '<i class="icon icon-top-third"></i>';
          break;
      }
      return index;
    },
  },
};
</script>
<style
  src="../../assets/styles/introduce-common.scss"
  lang="scss"
  scoped
></style>
<style lang="scss" scoped>
.block-wrap {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .block-members {
    width: 436px;
  }
  .block-rank {
    width: 596px;
  }
}
.block {
  .content-inner-wrap {
    .img-no-data {
      text-align: center;
      img {
        width: 200px;
      }
    }
    .studio-info {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      .avatar {
        margin-right: 20px;
        width: 100px;
        height: 100px;
        border-radius: 8px;
        border: 1px solid #f565a5;
      }
      .info {
        display: flex;
        flex-direction: column;
        justify-content: center;
        h2 {
          font-size: 20px;
          line-height: 26px;
          margin-bottom: 12px;
        }
        p {
          font-size: 16px;
          line-height: 21px;
        }
      }
    }
    .info-item {
      display: block;
      height: auto;
      overflow: hidden;
      margin-top: 20px;
      .label {
        width: 50px;
        float: left;
        font-size: 16px;
        line-height: 28px;
        color: #595959;
      }
      .details {
        width: 780px;
        float: left;
        font-size: 16px;
        line-height: 28px;
        color: #262626;
      }
    }
    .managementData {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      flex-wrap: wrap;
      .management-item {
        width: 478px;
        height: 98px;
        border-radius: 8px;
        background: #fafafa;
        display: flex;
        justify-content: space-between;
        padding: 13px 18px;
        cursor: pointer;
        border: 1px solid #fafafa;
        &.active {
          border-color: #ffc973;
          background-color: #fffaed;
        }
        h4 {
          font-size: 16px;
          line-height: 21px;
          color: #262626;
          margin-bottom: 11px;
          white-space: nowrap;
          em {
            font-size: 14px;
            line-height: 16px;
            color: #f56c6c;
          }
        }
        label {
          font-size: 24px;
          line-height: 31px;
          color: #fd9b21;
          i {
            font-size: 16px;
            line-height: 21px;
            color: #262626;
            margin-left: 8px;
          }
        }
        .mana-left {
          width: 222px;
        }
        .mana-right {
          width: 203px;
          position: relative;
          height: 100%;
          padding-left: 18px;
          &::before {
            position: absolute;
            display: block;
            content: '';
            width: 1px;
            height: 100%;
            background: #d9d9d9;
            top: 0;
            bottom: 0;
            left: 0;
            margin: auto;
          }
        }
      }
    }
    .managementRules {
      margin-top: 22px;
      p {
        font-size: 14px;
        line-height: 19px;
        margin-bottom: 7px;
        color: #8c8c8c;
        a {
          color: #2b6ddf;
          text-decoration: none;
        }
      }
    }
    .members-activity {
      .member {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0;
        }
        img {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          margin-right: 8px;
        }
        .member-info {
          display: flex;
          flex-direction: column;
          justify-content: center;
          p {
            font-size: 14px;
            line-height: 20px;
            color: #262626;
            margin-bottom: 4px;
            a {
              color: #2b6ddf;
              text-decoration: none;
            }
          }
          label {
            font-size: 14px;
            line-height: 20px;
            color: #8c8c8c;
          }
        }
      }
    }
    .tb-map {
      img {
        width: 83px;
        height: 50px;
        margin-right: 12px;
      }
      span {
        text-align: left;
        width: 142px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
    .tb-author {
      img {
        width: 24px;
        height: 24px;
        margin-right: 6px;
        border-radius: 50%;
      }
    }
  }
}
.block-rank {
  .title-wrap {
    margin-bottom: 14px;
  }
}
.block-flow,
.block-product {
  .content-inner-wrap {
    h3 {
      margin-bottom: 16px;
    }
    .managementData {
      margin-bottom: 30px;
      justify-content: flex-start;
      .management-item {
        width: 236px;
        margin-right: 15px;
        margin-bottom: 15px;
        &:nth-child(4n) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
<style lang="scss">
#rankTable {
  &::before {
    display: none;
  }
  td {
    padding: 8px 0;
    border-bottom: none;
    color: #8c8c8c;
  }
  .el-table__header-wrapper thead tr th {
    height: 54px;
    background: #fafafa;
    border-bottom: none;
    font-size: 14px;
    color: #000;
  }
  i.icon {
    display: block;
    margin: auto;
    width: 16px;
    height: 20px;
    background-size: 16px 20px;
    &.icon-top-first {
      background: url('../../assets/images/ico_top1.svg') center no-repeat;
    }
    &.icon-top-second {
      background: url('../../assets/images/ico_top2.svg') center no-repeat;
    }
    &.icon-top-third {
      background: url('../../assets/images/ico_top3.svg') center no-repeat;
    }
  }
}
#rankTable.el-table--scrollable-x .el-table__body-wrapper {
  overflow-x: hidden;
}
.content-inner-wrap {
  .tb-index,
  .tb-rankto,
  .tb-downloads {
    .cell {
      padding: 0;
    }
  }
  td.tb-map,
  td.tb-author {
    .cell {
      padding: 0;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
    }
  }
}
.block .content-inner-wrap .managementData .management-item label i {
  font-size: 16px;
  line-height: 21px;
  color: #262626;
  margin-left: 8px;
}
</style>
